module.exports = __webpack_public_path__ + "static/media/pr-create.d831a48e.svg";